import { api } from "./client";

export function planArticle(payload, { signal } = {}) { return api("/api/article/plan", { method: "POST", signal, json: payload }); }
export function writeArticle(payload, { signal } = {}) { return api("/api/article/write", { method: "POST", signal, json: payload }); }
export function articleStatus(job, { signal } = {}) { return api(`/api/article/status?job=${encodeURIComponent(job)}`, { signal }); }
